import { useAppDispatch, useAppSelector } from '../store/hooks';
import { selectSelectedSchema } from '../store/schemas/schemasSelector';
import { useCallback } from 'react';
import { setSelectedSchemaName } from '../store/schemas/schemasActions';
import { SchemaModel } from '../models/schemaModel';

export const useSelectedSchema = (): [
  SchemaModel | undefined,
  (schema: SchemaModel) => void,
] => {
  const dispatch = useAppDispatch();
  const selectedSchema = useAppSelector(selectSelectedSchema);

  const setSelectedSchema = useCallback((schema: SchemaModel) => {
    dispatch(setSelectedSchemaName(schema.name));
  }, [dispatch]);

  return [
    selectedSchema,
    setSelectedSchema,
  ];
};
